<h2 mat-dialog-title>{{ "HTL.NEXTINSPECTION.updateNextScheduledInspection" | translate }}</h2>
<mat-dialog-content class="mat-typography">
    <form #nextScheduledInspectionForm="ngForm" fxFlex="100" (ngSubmit)="onFormSubmit()" [formGroup]="nextInspectionFormGroup">
        <app-form-group-title [title]="'HTL.NEXTINSPECTION.calendarType' | translate"></app-form-group-title>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5px">
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.NEXTINSPECTION.firstCalendarType" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.NEXTINSPECTION.firstCalendarType' | translate" name="firstCalendarType" formControlName="firstCalendarType" />
                @if (nextInspectionFormGroup.controls["firstCalendarType"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.NEXTINSPECTION.nextDueAt" | translate }}</mat-label>
                <input
                    matInput
                    [matDatepicker]="calendarTypeDatePicker"
                    [placeholder]="'HTL.NEXTINSPECTION.nextDueAt' | translate"
                    name="firstCalendarNextDue"
                    formControlName="firstCalendarNextDue"
                    readonly
                />
                <mat-datepicker-toggle matSuffix [for]="calendarTypeDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #calendarTypeDatePicker></mat-datepicker>
                @if (nextInspectionFormGroup.controls["firstCalendarNextDue"].hasError("matDatepickerParse")) {
                    <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                }
                @if (nextInspectionFormGroup.controls["firstCalendarNextDue"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
        </div>
        <app-form-group-title [title]="'HTL.NEXTINSPECTION.hourlyType' | translate"></app-form-group-title>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5px">
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.NEXTINSPECTION.firstLimitHourlyType" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.NEXTINSPECTION.firstLimitHourlyType' | translate" name="firstLimitHourlyType" formControlName="firstLimitHourlyType" />
                @if (nextInspectionFormGroup.controls["firstLimitHourlyType"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.NEXTINSPECTION.nextDueAt" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.NEXTINSPECTION.nextDueAt' | translate" name="firstLimitHourlyNextDue" formControlName="firstLimitHourlyNextDue" />
                @if (nextInspectionFormGroup.controls["firstLimitHourlyNextDue"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
                @if (nextInspectionFormGroup.controls["firstLimitHourlyNextDue"].hasError("pattern")) {
                    <mat-error> {{ "GENERAL.hoursPatternError" | translate }}</mat-error>
                }
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>
        {{ "GENERAL.cancel" | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="nextScheduledInspectionForm.ngSubmit.emit()">
        {{ "GENERAL.save" | translate }}
    </button>
</mat-dialog-actions>
